module.exports = __webpack_public_path__ + "static/jasmine1-e5c7dd71cf52b464623a4640143b8c2a.jpg";